export default function useFormFields() {
  const CLIENT_FIELDS = [
    { name: "firstName", display: "First Name" },
    { name: "lastName", display: "Last Name" },
    { name: "job", display: "Job" },
    { name: "landline", display: "Phone" },
    { name: "mobile", display: "Mobile" },
    { name: "email", display: "Email" },
    { name: "address", display: "Address" },
    { name: "city", display: "City" },
    { name: "postalCode", display: "Postal Code" }
  ];

  const PROJECT_FIELDS = [
    [
      { name: "name", display: "Project Name" },
      { name: "workType", display: "Work Type" },
      { name: "workState", display: "Work State" }
    ],
    [
      { name: "budget", display: "Budget", detail: "€" },
      { name: "surface", display: "Surface Area", detail: "m²" }
    ],
    [{ name: "notes", display: "Notes" }],
    [
      { name: "address", display: "Address" },
      { name: "city", display: "City" },
      { name: "postalCode", display: "Postal Code" }
    ]
  ];

  return {
    CLIENT_FIELDS,
    PROJECT_FIELDS
  };
}
